import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';
import {classy} from 'webapp-lib/utils';

type Props = {
  children?: React.ReactNode;
} & React.TableHTMLAttributes<HTMLTableHeaderCellElement>;

const UFieldHeaderCell = ({
  className,
  children,
  ...props
}: Props): React.ReactElement => (
  <StyledFieldHeaderCell
    {...props}
    className={classy({
      [className ?? '']: Boolean(className),
      FieldHeaderCell: true,
    })}
  >
    {children}
  </StyledFieldHeaderCell>
);

export const FieldHeaderCell = observer(UFieldHeaderCell);

const StyledFieldHeaderCell = styled.th`
  grid-area: header;
  text-overflow: ellipsis;
  font-weight: var(--item-read-font-weight);
  font-size: var(--font-size-default);
  color: var(--color-core-primary);
  overflow: hidden;
  margin-top: var(--paragraph-spacing);
`;
